export interface IProductBase {
  productId: number;
  stockAvailability: EStockAvailability;
}

export interface IUsedProduct {
  usedId: number;
  volumeInPercent: number;
  descriptions: string[];
}

export interface IProductAttributesResponse {
  key: string;
  value: boolean;
}

export interface IProductAttributes {
  key: EProductAttribute;
  value: boolean;
}

export interface IBasicProductQuantity {
  unit?: string;
  currentQuantity: number;
}

export interface IVoucherDiscount {
  voucherCode: string;
  discountedPrice: number;
}

export enum EStockAvailability {
  OUT_OF_STOCK = 'OutOfStock',
  LAST_1 = 'Last1',
  LAST_2 = 'Last2',
  LAST_3 = 'Last3',
  LAST_4 = 'Last4',
  LAST_5 = 'Last5',
  MORE_THAN_5 = 'MoreThan5',
  MORE_THAN_20 = 'MoreThan20',
}

export enum EProductAttribute {
  UNKNOWN = 'Unknown',
  GIFT = 'Gift',
  FREE_DELIVERY = 'FreeDelivery',
  CLEARANCE = 'Clearance',
  NEW = 'New',
  ACTION = 'Action',
  BIO = 'Bio',
  DERMO = 'Dermo',
  NICHE = 'Niche',
  SAMPLE = 'Sample',
  MASTER = 'Master',
  WITHOUT_CELLOPHANE = 'WithoutCellophane',
  DIFFERENT_PACKAGING = 'DifferentPackaging',
  DAMAGE = 'Damage',
  EAN = 'EAN',
  FREE_GIFT_PACKAGING = 'FreeGiftPackaging',
  IS_FOR_PROFESSIONALS = 'IsForProfessionals',
  PACKAGE_SIZE = 'PackageSize',
  AIR_TRANSPORT_DISALLOWED = 'AirTransportDisallowed',
  IS_SPECIAL_SALES_OFFER = 'IsSpecialSalesOffer',
  IS_BLACK_FRIDAY_OFFER = 'IsBlackFridayOffer',
  AIR_TRANSPORT = 'AirTransport',
  PROHIBITED = 'Prohibited',
  PARTLY_PROHIBITED = 'PartlyProhibited',
  VOUCHER_DISCOUNT = 'VoucherDiscount',
}
